import { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { getQueryMetricsSnapshot, QueryMetricsSnapshot } from '../services/queryMetrics';

/**
 * Polls the real TanStack Query cache for the API performance metrics
 * PerformanceMonitor and ApiTestPanel display (task 4.4b). Dev-only
 * consumers; both are gated behind import.meta.env.DEV in App.tsx.
 */
export function useQueryMetrics(intervalMs = 5000): QueryMetricsSnapshot {
  const queryClient = useQueryClient();
  const [metrics, setMetrics] = useState<QueryMetricsSnapshot>(() => getQueryMetricsSnapshot(queryClient));

  useEffect(() => {
    const update = () => setMetrics(getQueryMetricsSnapshot(queryClient));
    update();
    const interval = setInterval(update, intervalMs);
    return () => clearInterval(interval);
  }, [queryClient, intervalMs]);

  return metrics;
}

export default useQueryMetrics;
